<div class="landing-promo-container" *ngIf="!isLoading">
  <ng-container *ngFor="let block of blocks">
    
    <!-- Hero Section -->
    <div *ngIf="block.type === 'hero'" class="hero-section">
      <div class="row align-items-center">
        <div class="col-lg-6 hero-text-col">
          <div class="exclusive-badge" *ngIf="block.props?.etiqueta">{{ block.props.etiqueta }}</div>
          
          <h1 class="main-title" *ngIf="block.props?.titulo || block.props?.subtitulo">
            <span class="title-p1" *ngIf="block.props?.titulo">{{ block.props.titulo }}</span>
            <br *ngIf="block.props?.titulo && block.props?.subtitulo">
            <span class="title-p2" *ngIf="block.props?.subtitulo" [style.color]="block.props?.colorMarca">{{ block.props.subtitulo }}</span>
          </h1>

          <div class="promo-subtitle" *ngIf="block.props?.ofertaArriba">{{ block.props.ofertaArriba }}</div>
          
          <div class="discount-container" *ngIf="block.props?.ofertaDescuento || block.props?.ofertaAbajo">
            <div class="discount-number" *ngIf="block.props?.ofertaDescuento" [style.color]="block.props?.colorMarca">{{ block.props.ofertaDescuento }}</div>
            <div class="discount-label" *ngIf="block.props?.ofertaAbajo">{{ block.props.ofertaAbajo }}</div>
          </div>

          <ul class="highlights-list" *ngIf="block.props?.ofertaBeneficios">
            <li *ngFor="let bullet of getHeroBullets(block.props?.ofertaBeneficios)">
              <span class="dot" [style.backgroundColor]="block.props?.colorMarca"></span>
              {{ bullet }}
            </li>
          </ul>

          <button class="btn-participate" *ngIf="block.props?.mostrarBoton !== false" (click)="scrollToSteps()" [style.backgroundColor]="block.props?.colorMarca">
            {{ block.props?.textoBoton || 'Ver más' }}
          </button>
        </div>
        
        <div class="col-lg-6" *ngIf="block.props?.imagenUrl">
          <div class="promo-image-wrapper">
            <img [src]="block.props.imagenUrl" class="promo-main-img" alt="Promo">
          </div>
        </div>
      </div>
    </div>

    <!-- Steps Section -->
    <div *ngIf="block.type === 'steps'" class="steps-section text-center">
      <h2 class="section-title" *ngIf="block.props?.titulo">{{ block.props.titulo }}</h2>
      <p class="section-subtitle" *ngIf="block.props?.subtitulo">{{ block.props.subtitulo }}</p>

      <div class="timeline-wrapper" *ngIf="block.props?.items || block.props?.pasos">
        <div class="timeline-line"></div>
        <div class="timeline-row">
          <div class="timeline-item" *ngFor="let paso of (block.props?.items || block.props?.pasos); let i = index">
            <div class="step-badge" [style.backgroundColor]="block.props?.colorMarca || '#f05a28'">{{ i + 1 }}</div>
            <div class="icon-circle" [style.borderColor]="block.props?.colorMarca || '#f05a28'">
              <span class="material-symbols-outlined" [style.color]="block.props?.colorMarca || '#f05a28'">{{ getMaterialIcon(paso.icono || paso.icon) }}</span>
            </div>
            <h3 class="step-title">{{ paso.titulo || paso.text }}</h3>
            <p class="step-desc" *ngIf="paso.descripcion">{{ paso.descripcion }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Grid Section -->
    <div *ngIf="block.type === 'grid'" class="details-section">
      <div class="row">
        <div class="col-12">
          <h2 class="details-title" *ngIf="block.props?.titulo" [style.color]="block.props?.colorMarca || '#0b752e'">
            | {{ block.props.titulo }}
          </h2>
          
          <div class="services-grid" *ngIf="block.props?.items">
            <div class="service-card" *ngFor="let item of block.props.items" [ngStyle]="{'background-color': item.bgColor || '#ffffff', 'border-color': item.borderColor || '#cfdbd1'}">
              <div class="card-badge" *ngIf="item.etiqueta" [style.backgroundColor]="item.colorEtiqueta || '#c86847'">{{ item.etiqueta }}</div>
              <div class="service-icon-wrapper">
                <span class="material-symbols-outlined">{{ getMaterialIcon(item.icono || item.icon) }}</span>
              </div>
              <h3 class="service-name">{{ item.titulo || item.text }}</h3>
              <p class="service-desc" *ngIf="item.descripcion || item.subtitulo">{{ item.descripcion || item.subtitulo }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Terms Section -->
    <div *ngIf="block.type === 'terms'" class="terms-section">
      <div class="terms-header" (click)="toggleTerms()" *ngIf="block.props?.content || block.props?.contenido">
        <h3 class="terms-title-text">{{ block.props?.titulo || 'TÉRMINOS Y CONDICIONES' }}</h3>
        <span class="material-symbols-outlined chevron-icon">
          {{ termsExpanded ? 'expand_less' : 'expand_more' }}
        </span>
      </div>
      <div class="terms-body" [class.show]="termsExpanded" *ngIf="block.props?.content || block.props?.contenido">
        <div class="terms-list" [innerHTML]="block.props?.content || block.props?.contenido"></div>
      </div>
    </div>

  </ng-container>
</div>

<!-- Loading State -->
<div *ngIf="isLoading" class="loading-state">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <p>Cargando promoción...</p>
</div>
